import styled from 'styled-components';
import theme from 'theme/theme';

const ErrorText = styled.p`
	margin: 7px 0 0 0;
	font-family: ${theme.monoFont};
	font-size: 11.5px;
	color: ${theme.danger};
`;

const FormError = styled.p`
	margin: 0 0 14px 0;
	font-size: 13.5px;
	color: ${theme.danger};
`;

const Sent = styled.div`
	max-width: 480px;
	border: 1px solid ${theme.rule};
	border-left: 3px solid ${theme.primary1};
	border-radius: 6px;
	padding: 22px 22px 20px 20px;
`;

const SentTitle = styled.h3`
	font-family: ${theme.headerFont};
	color: ${theme.chalk};
	font-size: 19px;
	margin: 0 0 8px 0;
`;

const SentText = styled.p`
	margin: 0;
	font-size: 14.5px;
	line-height: 1.7;
	color: ${theme.chalk};
	opacity: 0.72;
`;

export { ErrorText, FormError, Sent, SentTitle, SentText };
